import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useCallback } from 'react';

export default function useRemoveOneSearchParam() {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const removeOneSearchParam = useCallback(
    (paramsToRemove: string) => {
      if (!Array.isArray(paramsToRemove) || paramsToRemove.length === 0) return;
      const current = new URLSearchParams(Array.from(searchParams.entries()));
      current.delete(paramsToRemove);

      const search = current.toString();
      const query = search ? `?${search}` : '';

      router.replace(`${pathname}${query}`);
    },
    [router, pathname, searchParams],
  );

  return removeOneSearchParam;
}
